import HeroInvestors from './HeroInvestors';
export default HeroInvestors;
